<template>
  <div class="view-max-shell">
    <div class="w-view-shell">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }"
        >当前位置：首页</el-breadcrumb-item
        >
        <el-breadcrumb-item>帮助中心</el-breadcrumb-item>
      </el-breadcrumb>

      <van-cell is-link v-for="(item,index) in list" :key="index" @click="handle(item,index)">
        <template #title>
          <img class="img" :src="item.icon" alt="" />
          <span>{{item.name}}</span>
        </template>
      </van-cell>
    </div>
  </div>
</template>

<script>
export default {
  name: "help",
  data(){
    return{
      // 1.操作手册；2.修改信息；3.开具发票，4，上传头像；5.考核相关 6 .联系我们
      list: [
        {
          name: '操作手册',
          icon: require('@/assets/caozuo.png'),
          path: '',
          code: 1
        },
        {
          name: '修改信息',
          icon: require('@/assets/xiugai.png'),
          code: 2
        },
        {
          name: '开具发票',
          icon: require('@/assets/kaiju.png'),
          code: 3
        },
        {
          name: '上传头像',
          icon: require('@/assets/shangchuan.png'),
          code: 4
        },
        {
          name: '考核相关',
          icon: require('@/assets/lianxi.png'),
          code: 5
        },
        {
          name: '联系我们',
          icon: require('@/assets/caozuo.png'),
          code: 6
        },
      ],
    }
  },
  methods:{
    handle(item,index){
      this.$router.push('/issue?name='+ item.name +'&protocol_type='+item.code)
    }
  }
};
</script>

<style lang="less" scoped>
  .view-max-shell{
    width: 100%;
    min-height: 100vh;
    background-color: #fff;
  }
.el-breadcrumb__item:last-child .el-breadcrumb__inner,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 400;
  color: #000;
  cursor: text;
}
.el-breadcrumb {
  display: flex;
  align-items: center;
  height: 100px;
  /*margin-top: 30px;*/
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}
.van-cell {
  position: relative;
  width: 100%;
  height: 92px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  margin: 0 0 30px 0;
  .img {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    width: 32px;
    height: 36px;
  }
  .img1 {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    width: 36px;
    height: 37px;
  }
  .img2 {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    width: 32px;
    height: 37px;
  }
  .img3 {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    width: 42px;
    height: 42px;
  }
  .img4 {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    width: 32px;
    height: 40px;
  }
  .img5 {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    width: 33px;
    height: 39px;
  }
  span {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    width: 96px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    margin-left: 50px;
  }
  /deep/.van-icon {
    top: 32%;
  }
}
</style>
